import React from "react";
import { Activity, Heart, ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurApproachToCare() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="46965" id="life-at-riverbend" ref={ref} className={`bg-background text-foreground py-16 md:py-24 overflow-hidden transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 xl:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <p className="text-secondary font-default font-bold tracking-widest uppercase text-sm mb-4">
              Our Culture
            </p>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-500 leading-tight mb-6">
              Professional work grounded in practical values.
            </h2>

            <div className="space-y-5 text-base md:text-lg font-default text-muted-foreground leading-relaxed">
              <p>
                RiverBend’s work requires care, judgment, and follow-through. We
                support First Nation communities, Northern organizations,
                businesses, and partnerships with work that often involves
                complex financial information, reporting deadlines, project
                demands, and important decisions.
              </p>

              <p>
                Our team culture is built around practical problem-solving,
                respectful communication, dependable work, and steady support
                for the clients we serve. We value people who can think clearly,
                learn continuously, and help move important work forward without
                losing sight of the people and communities behind the files.
              </p>

              <p>
                We also believe good work should be sustainable. RiverBend aims
                to create a professional environment where people can contribute
                meaningfully, develop their skills, and do work that supports
                long-term stability and capacity for clients.
              </p>
            </div>

            <div className="mt-8 bg-secondary/10 border border-secondary/20 rounded-lg p-5 flex items-start gap-4">
              <div className="size-11 rounded-md bg-secondary/10 flex items-center justify-center shrink-0">
                <ShieldCheck className="size-5 text-secondary" />
              </div>

              <div>
                <h3 className="text-lg font-default font-bold text-primary-500 mb-2">
                  A practical and respectful standard
                </h3>

                <p className="text-muted-foreground font-default leading-relaxed">
                  We focus on clear communication, reliable systems, thoughtful
                  judgment, and work that helps clients understand where they
                  are and what needs to happen next.
                </p>
              </div>
            </div>

            <div className="mt-8">
              
              
            </div>
          </div>

          <div className="lg:col-span-6 relative order-1 lg:order-2">
            <div className="relative group">
              <div className="absolute inset-0 border border-secondary/25 translate-x-4 translate-y-4 rounded-2xl -z-10 transition-transform duration-700 group-hover:translate-x-2 group-hover:translate-y-2" />

              <div className="relative rounded-2xl overflow-hidden shadow-xl border border-border bg-muted">
                <img src="https://stable-woodcock.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-16-2026-08_21_30-AM.png" alt="Professional workspace overlooking a Northern landscape" className="w-full h-full object-cover aspect-[4/3] transition-transform duration-700 group-hover:scale-105" loading="lazy" />

                <div className="absolute inset-0 bg-gradient-to-tr from-primary/15 to-transparent pointer-events-none" />
              </div>
            </div>

<Card className="absolute -bottom-5 left-6 md:left-8 w-[280px] md:w-[320px] shadow-xl border-border bg-card/95 backdrop-blur-sm rounded-lg">
  <CardContent className="p-4 flex flex-col gap-2.5">
    <div className="flex items-center justify-between gap-4">
      <Badge variant="secondary" className="bg-secondary/10 text-secondary hover:bg-secondary/20 px-3 py-1 text-xs font-default">
        Meaningful Work
      </Badge>

      <Heart className="w-4 h-4 text-secondary fill-secondary/20" />
    </div>

    <p className="text-foreground font-default font-medium leading-snug text-sm">
      Helping clients build clearer information, stronger systems, and better
      capacity to move important work forward.
    </p>

    <div className="flex items-center gap-2 text-[11px] text-muted-foreground mt-1 font-default">
      <Activity className="w-3 h-3" />
      <span>Practical support • Respectful relationships</span>
    </div>
  </CardContent>
</Card>
          </div>
        </div>
      </div>
    </section>;
}